import { getInputMask } from "../../helpers/currency";

export const radiusInput = (value, name) => {
    let newValue = value ? value.replace(/[^\d]/g, "") : "";
    newValue = parseInt(newValue) > 999 ? 999 : newValue;
    return !!parseInt(newValue) === false ? "" : parseInt(newValue);
    // return newValue;
};

export const numberInput = (value, name) => {
    let newValue = value
        ? value
              .toString()
              .replace(/[^\d.,]/g, "")
              .replace(/[,]/, ".")
        : "";
    return newValue;
};

export const priceInput = (value) => {
    let newValue = value ? value.toString().replace(/[^\d]/g, "") : "";
    return getInputMask(newValue);
};

export const floatNormalize50 = (value) => {
    return !value || !value.length || value[value.length - 1] === "."
        ? value
        : parseFloat(value) > 50
        ? "50"
        : parseFloat(value);
};

export const input9999 = (value) => {
    let newValue = value
        ? value
              .toString()
              .replace(/[^\d.,]/g, "")
              .replace(/[,]/, ".")
        : "";
    return !newValue || !newValue.length || newValue[value.length - 1] === "."
        ? newValue
        : parseFloat(newValue) > 9999
        ? "9999"
        : parseFloat(newValue);
};

export const input50 = (value) => {
    let newValue = value
        ? value
              .toString()
              .replace(/[^\d.,]/g, "")
              .replace(/[,]/, ".")
        : "";
    return !newValue || !newValue.length || newValue[newValue.length - 1] === "."
        ? newValue
        : parseFloat(value) > 50
        ? "50"
        : parseFloat(newValue);
};

export const floatNormalize9999 = (value) => {
    return !value || !value.length || value[value.length - 1] === "."
        ? value
        : parseFloat(value) > 9999
        ? "9999"
        : parseFloat(value);
};

export const onlyNumberInput = (value, name) => {
    let newValue = value ? value.toString().replace(/[^\d]/g, "") : "";
    return !!parseInt(newValue) === false ? "" : parseInt(newValue);
};

/** Keeps only digits (for INN, account numbers, etc.). Returns string. */
export const digitsOnlyInput = (value) => (value || "").toString().replace(/\D/g, "");

export const daysInput = (value, name) => {
    let newValue = value ? value.replace(/[^\d]/g, "") : "";
    newValue = parseInt(newValue) > 10 ? 10 : newValue;
    return !!parseInt(newValue) === false ? "" : parseInt(newValue);
};

export const percentsInput = (value, name) => {
    let newValue = value ? value.replace(/[^\d]/g, "") : "";
    newValue = parseInt(newValue) > 100 ? 100 : newValue;
    return !!parseInt(newValue) === false ? "" : parseInt(newValue);
};

export const timeInput = (value, name) => {
    if (value) {
        let newValue = value ? value.replace(/[^\d]/g, "") : "";
        if (Number(newValue) > 24) newValue = 24;
        if (Number(newValue) < 0) newValue = 0;
        return newValue;
    }
    return value;
};

export const timeInputHHMM = (value) => {
    if (!value) return value;

    // Remove all non-digit characters except colon
    let cleaned = value.replace(/[^\d:]/g, "");

    // Handle input without colon
    let digits = cleaned.replace(/:/g, "");

    if (digits.length === 0) return "";

    // Format as HH:MM
    let hours = digits.slice(0, 2);
    let minutes = digits.slice(2, 4);

    // Validate hours (0-23)
    if (hours.length === 2 && Number(hours) > 23) {
        hours = "23";
    }

    // Validate minutes (0-59)
    if (minutes.length === 2 && Number(minutes) > 59) {
        minutes = "59";
    }

    if (digits.length <= 2) {
        return hours;
    }

    return `${hours}:${minutes}`;
};

export const onlyTextInput = (value, name) => {
    let newValue = value ? value.replace(/[^\wА-Яа-яёЁ,]/g, "").replace(/[\d]/g, "") : "";
    return newValue;
};

export const regNumber = (value, name) => {
    let newValue = value ? value.replace(/[^\wА-Яа-яёЁ\d-]/g, "") : "";
    return newValue;
};
